export function isEmbeddedFormImage(value) {
  return /^data:image\/(?:png|jpeg);base64,[a-z0-9+/=]+$/i.test(String(value || "").trim());
}

const CONTENT_MARKERS = /\[(?:b|\/b|u|\/u|size=(?:large|xlarge)|\/size)\]/gi;

// Info text is stored as plain text with a deliberately small set of paired
// formatting markers. Never interpret it as HTML from a form editor.
export function parseFormContent(value) {
  const source = String(value || "");
  const runs = [];
  const stack = [];
  let position = 0;

  const append = (text) => {
    if (!text) return;
    const bold = stack.some((item) => item.type === "b");
    const underline = stack.some((item) => item.type === "u");
    const size = [...stack].reverse().find((item) => item.type === "size")?.size || "normal";
    const last = runs[runs.length - 1];
    if (last && last.bold === bold && last.underline === underline && last.size === size) {
      last.text += text;
    } else {
      runs.push({ text, bold, underline, size });
    }
  };

  for (const match of source.matchAll(CONTENT_MARKERS)) {
    append(source.slice(position, match.index));
    const marker = match[0].toLowerCase();
    const closing = marker.startsWith("[/");
    const type = marker.includes("size") ? "size" : marker.slice(closing ? 2 : 1, -1);
    if (closing) {
      if (stack[stack.length - 1]?.type === type) stack.pop();
      else append(match[0]);
    } else {
      const closeMarker = `[/${type}]`;
      if (source.toLowerCase().indexOf(closeMarker, match.index + match[0].length) === -1) {
        append(match[0]);
      } else {
        stack.push({ type, size: marker.match(/^\[size=(large|xlarge)\]$/)?.[1] });
      }
    }
    position = match.index + match[0].length;
  }
  append(source.slice(position));
  return runs;
}
